import LabServiceModel from "@/models/LabServiceModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
import TestPackageGroupModel from "@/models/lab/TestPackageGroupModel";
import TestPackageSampleCollection from "@/collections/lab/TestPackageSampleCollection";
import SubmissionCollection from "@/collections/lab/SubmissionCollection";

export default class TestPackageModel extends LabServiceModel {
  modelName() {
    return 'test-package';
  }
  icon() {
    return 'shovel';
  }
  routes() {
    const routes = super.routes();

    routes.apply = `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/${this.modelName()}/{id}/apply`

    return routes;
  }
  defaults() {
    return {
      id: null,
      sample_type_id: null,
      sample_type: null,
      test_package_group_id: null,
      test_package_group: null,
      laboratory_id: null,
      laboratory: null,
      name: null,
      cost: null,
      cost_add_on: null,
      description: null,
      position: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      test_package_samples: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      sample_type_id: (val) => (this.nullStringMutator(val)),
      test_package_group_id: (val) => (this.nullStringMutator(val)),
      laboratory_id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      cost: (val) => (this.nullStringMutator(val)),
      cost_add_on: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getSampleType() {
    return this.getRelatedModel(SampleTypeModel, 'sample_type');
  }
  getTestPackageGroup() {
    return this.getRelatedModel(TestPackageGroupModel, 'test_package_group');
  }
  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, 'laboratory');
  }
  getSubmissions() {
    return this.getRelatedCollection(new SubmissionCollection(), 'submissions');
  }
  getTestPackageSamples() {
    return this.getRelatedCollection(new TestPackageSampleCollection(), 'test_package_samples');
  }
  apply (data) {
    const method = this.getMethod('create')
    const route = this.getRoute('apply')
    const url = this.getURL(route, { id: this.get('id') })

    return this.createRequest({ method, url, data }).send().then(response => {
      this.emit('apply', {})

      return response
    })
  }
}
